import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { ComfirmComponent } from './confirm.component';
import { MatDialog, MatDialogRef } from '@angular/material';

import { locale as traduccion } from '../../../i18n/es';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ConfirmService {

  constructor(private dialog: MatDialog, private translate: TranslateService) { }

  public confirm(title: string, message: string): Observable<boolean> {
    let dialogRef: MatDialogRef<ComfirmComponent>;
    let aceptar, cancelar;
    const traducciones = [title, message, traduccion.data.ACEPTAR, traduccion.data.CANCELAR]; 
    this.translate.get(traducciones).subscribe(
      data => {        
        title = data[title.valueOf()];        
        message = data[message.valueOf()];
        aceptar = data[traduccion.data.ACEPTAR.valueOf()];
        cancelar = data[traduccion.data.CANCELAR.valueOf()];
        dialogRef = this.dialog.open(ComfirmComponent, {disableClose: true});
        dialogRef.updateSize('380px');
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.aceptar = aceptar;
        dialogRef.componentInstance.cancelar = cancelar;
      }, 
      err => {        
        dialogRef = this.dialog.open(ComfirmComponent, {disableClose: true});
        dialogRef.updateSize('380px');
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.aceptar = traduccion.data.ACEPTAR;
        dialogRef.componentInstance.cancelar = traduccion.data.CANCELAR;
      }
    );
    return dialogRef.afterClosed();      
    
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/confirm/confirm.service.ts